import React from 'react';
import styled from 'styled-components';

import Button from './Button';
import { colors } from '@styles/theme';
import { Text } from '@neta';
import { toRoundedDollars as toDollars } from '@lib/toDollars';

const Container = styled.div`
  display: inline-flex;
  border: ${({ theme }) => theme.borders.divider};
  border-radius: 4px;
  overflow: hidden;

  > button {
    border-right: 1px solid #d3d3db;

    &:last-child {
      border-right: none;
    }
  }
`;

export default class ButtonGroup extends React.PureComponent {
  render() {
    const {
      onChange,
      onClick,
      options,
      value,
      scopeColoredBottomBorder = false,
      scopeColoredBgOnFocused = false
    } = this.props;
    return (
      <Container onClick={onClick ? onClick : undefined}>
        {options.map(({ name, value: optionValue, amountInCents = undefined }) => {
          const active = value === optionValue;
          const Component = active
            ? Button.buttonGroupActive
            : Button.buttonGroupInactive;
          let style = {};
          if (scopeColoredBottomBorder) {
            style.borderBottom = `3px solid ${
              optionValue === 'all' ? colors.primary : colors[optionValue]
            }`;
          }
          let textStyle = {};

          if (scopeColoredBgOnFocused) {
            style.backgroundColor = active
              ? optionValue === 'all'
                ? colors.primary
                : colors[optionValue]
              : undefined;
            textStyle.color = active
              ? ['partner', 'personal'].includes(optionValue)
                ? 'black'
                : 'white'
              : 'black';
            textStyle.fontWeight = active ? 'bold' : undefined;
          }

          if (optionValue === 'all') style.minWidth = '5rem';
          return (
            <Component
              key={optionValue}
              data-testid={`button-group-button${active ? '-active' : ''}`}
              onClick={() => onChange(optionValue)}
              style={style}
            >
              <Text style={textStyle}>
                {name}
                {amountInCents !== undefined ? (
                  <>
                    <br />
                    {toDollars(amountInCents)}
                  </>
                ) : null}
              </Text>
            </Component>
          );
        })}
      </Container>
    );
  }
}
